@if (!loading) {
  <div>
    <metadata-panel view-only="true" [model]="displayModel" [metadata]="metadata" [dense]="dense">
  </metadata-panel>
</div>
}
